
import CodingPlayground from "./CodingPlayground";

const AlgorithmPlayground = () => {
  return (
    <div className="w-full mb-6">
      <CodingPlayground />
    </div>
  );
};

export default AlgorithmPlayground;
